import { Button as e } from "../Button/Button.js";
import t from "./Calendar.module.js";
import { jsx as n, jsxs as r } from "react/jsx-runtime";
//#region lib/components/DatePicker/CalendarFooter.tsx
function i({ onCancel: i, onApply: a, applyDisabled: o }) {
	return /* @__PURE__ */ r("div", {
		className: t.footer,
		children: [/* @__PURE__ */ n(e, {
			className: t.footerButton,
			color: "neutral",
			size: "lg",
			onClick: i,
			children: "Cancel"
		}), /* @__PURE__ */ n(e, {
			className: t.footerButton,
			color: "primary",
			size: "lg",
			disabled: o,
			onClick: a,
			children: "Apply"
		})]
	});
}
//#endregion
export { i as CalendarFooter };
